import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CouponLineContainerModel } from '../../../../../../models/aggregates/erp/coupon';
import { Core2Config } from '../../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';

@Injectable({ providedIn: 'root' })
export class CouponLineV2Service extends BaseApiPublicLoginTemplateService<CouponLineContainerModel, CouponLineContainerModel, CouponLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines/login-ep';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines/login-entity-ep';
    this.endpoint_path_website_ep_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupon/lines/website-ep';
    this.httpClient = http;
  }

  createLine(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.apiUrl;
      }
      return this.httpClient.post<ApiResponseModel<any>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }


  traceCoupon(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    const traceUrl = visa.api_domain_url + this.apiUrl + "/trace-coupon/backoffice-ep";

    return this.httpClient.post<ApiResponseModel<any>>(
        traceUrl,  // Use the local variable
        dtoObject,
        this.getHttpHeader(visa)
      );
  }
}
